import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Meta, Title } from '@angular/platform-browser';
import { SeoService } from '../../../../service/seo.service';
import { NavigationEnd, Router } from '@angular/router';
import { UrlcanonicaService } from '../../../../service/urlcanonica.service';
import { filter } from 'rxjs/operators';
import { LicitacionService } from '../../../../service/licitacion.service';

@Component({
  selector: 'app-login-admin',
  templateUrl: './login-admin.component.html',
  styleUrls: ['./login-admin.component.css']
})
export class LoginAdminComponent implements OnInit {

	RouteText : any;
	tituloseo: any;
	urlcanonicaseo: any;
	imagenseo: any;
	keywordsseo: any;
	descripcionseo: any;
	fieldTextType: boolean = false;

	//////
	success= false;
	fail = false;
	formsend: any;
	/////

	constructor( 
		private meta: Meta,
		private title: Title,
		private _seoService: SeoService,
		private router: Router,
		private _licitacionservice: LicitacionService,
		private _urlcanonicaservice: UrlcanonicaService
		) { 
			this.router.events.pipe(filter((event: any) =>  event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
				this.RouteText = event;
				this.getSEO(event.url)
			});
		}

	toggleFieldTextType() {
		this.fieldTextType = !this.fieldTextType;
	}

	getSEO(page: string) {
		this._seoService.getSEO(page).subscribe((resp: any) => {
		this.tituloseo = resp.titulo;
		this.descripcionseo = resp.descripcion;
		this.urlcanonicaseo = resp.urlcanonica;
		this.imagenseo = resp.image;
		
		this._urlcanonicaservice.createCanonicalLink();
		this.title.setTitle(this.tituloseo)
		this.meta.updateTag({name: 'description',content: this.descripcionseo})
		this.meta.updateTag({property: 'twitter:card',content: 'summary'})
		this.meta.updateTag({property: 'twitter:site',content: '@fundacionbest'})
		this.meta.updateTag({property: 'twitter:title',content: 'Fundación BEST'})
		this.meta.updateTag({property: 'twitter:description',content: this.descripcionseo})
		this.meta.updateTag({property: 'twitter:image',content: this.imagenseo})
		this.meta.updateTag({property: 'og:url',content: 'https://fundacionbest.org.mx/licitaciones/login'})
		this.meta.updateTag({property: 'og:title',content: this.tituloseo})
		this.meta.updateTag({property: 'og:image',content: this.imagenseo})
		this.meta.updateTag({property: 'og:description',content: this.descripcionseo})
		});
	}

	ngOnInit(): void {
	}

	//////////
	onSubmit(form: NgForm) {
		
		const formulario = {
				Usuario: form.value.usuario,
				password: form.value.password
			}

		this._licitacionservice.postLoginLicAdm(formulario).subscribe((resp: any) => {
			
			sessionStorage.setItem('token', resp.token);
			sessionStorage.setItem('user', form.value.usuario);
			form.reset();
			this.success = true;
			this.router.navigate(['/licitaciones/administrador/familias']);
		},
		e => {
		this.fail = true;
		//this.isLoading = false;
		}
	);

	}

	closeok() {
		this.fail = false;
	}

}